import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { STATE_ABBR, SET_SELECTED_SITE } from "./complianceConstants";
import {
  Accordion as MuiAccordion,
  AccordionSummary,
  AccordionDetails,
  Table,
  TableCell,
  TableRow,
} from "@material-ui/core";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import './Compliance.scss';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import ReportProblemIcon from '@material-ui/icons/ReportProblem';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'; //circle
import StopIcon from '@material-ui/icons/Stop';
import Tooltip from '@material-ui/core/Tooltip';
import Box from '@material-ui/core/Box';
export const RenderComplianceTopHeader = ({title, subtitle}) => {
  const dispatch = useDispatch();
  const selectedSite = useSelector(
      (state) => state.ComplianceReducer.selectedSite?.name
    );
  const handleSiteChange = (event) => {
    const newSite = {name: event.target.value, abbr: STATE_ABBR[event.target.value]};
    dispatch({ type: SET_SELECTED_SITE, payload: { selectedSite: newSite } });
  };
  const visitedStates = useSelector(
    (state) => state.ComplianceReducer.stateList
  );
  return (
    <div className="complianceHeader compliance">
      <div className="complianceSecondaryHeader">
        <div className="riskGovernanceHeaderContainer">
          <div>
            <h2 className="complianceTitle">{title}</h2>
            <h3 className="compliance-sub-title">{subtitle}</h3>
          </div>
          {selectedSite && (
            <div className="siteDropdownContainer">
              <span className="siteLabel">Site: </span>
              <select
                className="siteDropdown"
                value={selectedSite}
                onChange={handleSiteChange}
              >
                {visitedStates.map((state) => (
                  <option key={state} value={state}>
                    {state}
                  </option>
                ))}
              </select>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export const renderCompliantIcon = (compliant, title = null) => {
  if (compliant === 'Yes') {
    return <Tooltip title="Yes"><DoneAllIcon className='color-green' /></Tooltip>;
  } else if (compliant === 'No') {
    return <Tooltip title="No"><ReportProblemIcon className='color-red' /></Tooltip>;
  } else {
    return <Tooltip title="Unknown"><ErrorOutlineIcon className='color-error' /></Tooltip>;
  }
};

export const renderCIAIcon = (value) => {
  if (value === 'Yes') {
    return <Tooltip title="Yes"><StopIcon className='color-green' /></Tooltip>;
  } else if (value === 'No') {
    return <Tooltip title="No"><StopIcon className='color-red' /></Tooltip>;
  } else {
    return <Tooltip title="Unknown"><StopIcon className='color-error' /></Tooltip>;
  }
};

export const Accordion = ({ item, onChange, isExpanded, children, yesObj }) => {
  const yesPercent = (yesObj && yesObj.value) ? Math.round(yesObj.value) + '%' : '';
  return (
    <Box boxShadow={3} bgcolor="background.paper"
      m={1}>
      <MuiAccordion onChange={onChange} expanded={isExpanded}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Table>
            <TableRow className='tbl-header-row'>
              <TableCell className='cell-width acc-title'>{item.sectionDescription}</TableCell>
              <TableCell className='cell-width align-center' title='Confidentiality'>{isExpanded ? (<>C</>) : null}</TableCell>
              <TableCell className='cell-width align-center' title='Integrity'>{isExpanded ? (<>I</>) : null}</TableCell>
              <TableCell className='cell-width align-center' title='Availability'>{isExpanded ? (<>A</>) : null}</TableCell>
              <TableCell className='cell-width align-center color-green' title={yesPercent + ' Compliance'}>{yesPercent}</TableCell>
              <TableCell className='cell-width align-center'>{item.remark}</TableCell>
            </TableRow>
          </Table>
        </AccordionSummary>
        <AccordionDetails className='pad-0'>{children}</AccordionDetails>
      </MuiAccordion>
    </Box>
  );
};